import script from "./BaseTextElement.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseTextElement.vue?vue&type=script&lang=ts&setup=true"

import "./BaseTextElement.vue?vue&type=style&index=0&id=52a206f2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52a206f2"]])

export default __exports__